import {Component, OnInit} from '@angular/core';
import {ApiService} from '../service/api.service';
import {UserService} from '../service/user.service';

@Component({
  selector: 'user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  constructor(private apiService: ApiService,
              private userService: UserService) {
  }

  ngOnInit() {
  }
}
